import { useEffect, useState } from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { PostCard } from "../components/PostCard";
import { api } from "../lib/api";

const BANNER = "https://images.pexels.com/photos/204511/pexels-photo-204511.jpeg";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/posts", { params: { type: "blog" } })
      .then((r) => setPosts(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <Navbar />
      <section className="relative h-[50vh] min-h-[360px] flex items-end overflow-hidden">
        <img src={BANNER} alt="Notebook and pen with coffee" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A] to-[#1A1A1A]/30" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 pb-14 w-full">
          <p className="label-caps text-[#D4AF37] mb-4">Learn &amp; grow</p>
          <h1 className="font-serif-display text-5xl sm:text-6xl font-light text-[#F7F5F0]">Blog &amp; Resources</h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-20" data-testid="blog-list">
        {loading ? (
          <p className="text-[#737373]">Loading articles…</p>
        ) : posts.length === 0 ? (
          <p className="text-[#737373]">No articles published yet. Check back soon.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {posts.map((p, i) => <PostCard key={p.id} post={p} index={i} />)}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
